export enum ERole {
    Undefined = 0,
    Reception = 5,
    Employee = 10,
    Leader = 20,
    Supervisor = 28419,
    Admin = 30,
    Manager = 35742,
    LimitedClient = 12520,
    Client = 76529,
    SuperAdmin = 99789,
}

export const AllHBscanRoles = [
    ERole.Employee,
    ERole.Leader,
    ERole.Admin,
    ERole.Manager,
    ERole.Supervisor,
    ERole.SuperAdmin,
    ERole.Client,
    ERole.LimitedClient,
];
